import { queryOptions, useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import { responseScheme } from '@/models/response';
import { fetcher } from '@/utils/fetcher';

const userQrCodeScheme = responseScheme.extend({
  QRCode: z.string().url(),
});

type UserQrCodeType = z.infer<typeof userQrCodeScheme>;

export const userQrCodeQueryOptions = queryOptions({
  queryKey: ['/GetUserQRCode'],
  queryFn: ({ signal }) =>
    fetcher<UserQrCodeType>('/GetUserQRCode', undefined, {
      signal,
      schema: userQrCodeScheme,
      validResponseCodes: [0],
    }).then((response) => response?.QRCode ?? null),
  refetchOnWindowFocus: false,
});

export default function useUserQrCode() {
  return useQuery(userQrCodeQueryOptions);
}
